import type { PageLoadPerformanceEventProperties } from '@ms/yammer-telemetry-support';

type PageLoadTerminalProperties = Pick<
  PageLoadPerformanceEventProperties,
  'endedWithError' | 'interrupted' | 'timedOut'
>;

export const getPageLoadTerminalProperties = (
  eventProperties: Partial<PageLoadPerformanceEventProperties>
): PageLoadTerminalProperties => ({
  endedWithError: eventProperties.endedWithError ?? false,
  interrupted: eventProperties.interrupted ?? false,
  timedOut: eventProperties.timedOut ?? false,
});
